module.exports = __webpack_public_path__ + "static/media/vf-button-dress.97f840b2.svg";